var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.99984H2.66667M2.66667 4.99984H16M2.66667 4.99984V16.6665C2.66667 17.1085 2.84226 17.5325 3.15482 17.845C3.46738 18.1576 3.89131 18.3332 4.33333 18.3332H12.6667C13.1087 18.3332 13.5326 18.1576 13.8452 17.845C14.1577 17.5325 14.3333 17.1085 14.3333 16.6665V4.99984H2.66667ZM5.16667 4.99984V3.33317C5.16667 2.89114 5.34226 2.46722 5.65482 2.15466C5.96738 1.8421 6.39131 1.6665 6.83333 1.6665H10.1667C10.6087 1.6665 11.0326 1.8421 11.3452 2.15466C11.6577 2.46722 11.8333 2.89114 11.8333 3.33317V4.99984M6.83333 9.1665V14.1665M10.1667 9.1665V14.1665",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.249138312360eb7f410f746624bccb16.svg";
export { ForwardRef as ReactComponent };